import { ApplicationState } from 'ducks/application-state';

export const selectScores = (state: ApplicationState) => state.score.list;
export const selectScore = (state: ApplicationState) => state.score.item;
export const selectScoresPagination = (state: ApplicationState) => state.score.pagination;
export const selectScoresSort = (state: ApplicationState) => state.score.sort;
export const selectScoresLoading = (state: ApplicationState) => state.score.loading;
